
import { useDispatch } from "react-redux";
import { setMessage } from "../redux/actions/auth"
import getDate from "./getDate";

export const useCheckUserBlock = (user) => {
  const dispatch = useDispatch();
  
  return (user) => {
    if (user.isBlock === 1) {
      if (user.userBlock) {
          dispatch(setMessage({
            type: 'error',
            message: `Ваш акаунт заблоковано до: ${getDate(user.userBlock, 'dd/mm/yyyy hh:mm', '.')}`
          }))
      } else {
        dispatch(setMessage({
          type: 'error',
          message: `Ваш акаунт заблоковано`
        }))
      }

      return false;
    }

    return true;
  }
}